import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as fastDeepEqual from 'fast-deep-equal';
import { distinctUntilChanged, filter, take } from 'rxjs/operators';
import { combineLatest } from 'rxjs';

import * as ApplicationStatusesActions from './application-statuses.actions';
import * as ApplicationStatusesSelectors from './application-statuses.selectors';

@Injectable()
export class ApplicationStatusesFacade {
  applicationStatuses$ = (typeId: string) =>
    this.store.pipe(
      select(ApplicationStatusesSelectors.getStatuses(typeId)),
      filter((statuses) => statuses != null),
      distinctUntilChanged(fastDeepEqual)
    );

  applicationStatusesLoaded$ = (typeId: string) =>
    this.store.pipe(
      select(ApplicationStatusesSelectors.getStatusesLoaded(typeId)),
      distinctUntilChanged()
    );

  applicationStatusesLoading$ = (typeId: string) =>
    this.store.pipe(
      select(ApplicationStatusesSelectors.getStatusesLoading(typeId)),
      distinctUntilChanged()
    );

  constructor(private store: Store) {}

  dispatchGetApplicationStatuses(typeId: string, override = false) {
    combineLatest([
      this.store.pipe(
        select(ApplicationStatusesSelectors.getStatusesLoaded(typeId))
      ),
      this.store.pipe(
        select(ApplicationStatusesSelectors.getStatusesLoading(typeId))
      ),
    ])
      .pipe(take(1))
      .subscribe(([loaded, loading]) => {
        if ((loaded && !override) || loading) {
          return;
        }
        this.store.dispatch(
          ApplicationStatusesActions.getApplicationStatuses({ typeId })
        );
      });
  }
}

